module.exports = {"name":"search","parameters":[{"name":"suggestionsSearchEngine","valid":["ALGOLIA","OPENSEARCH"],"value":"ALGOLIA"}]}